import { inject } from './inject';
import { PaymentCardExpiration as BasePaymentCardExpiration } from './PaymentCardExpiration';

export const PaymentCardExpiration = inject(BasePaymentCardExpiration);
